import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useTagState() {
  return useAppState();
}

export function useTagActions() {
  const dispatch = useAppDispatch();

  function initializeState(id) {
    dispatch((state) => ({
      ...state,
      tag: {
        id,
        value: '',
        normalizedValue: '',
        unreviewedTaggingRules: [],
        allowedTaggingRules: [],
        deniedTaggingRules: [],
      },
      updateTagForm: {
        id,
        value: '',
      },
      tagTypeOptions: [],
      taggableTypeOptions: [],
      newAllowedTaggingRuleForm: {
        tagId: id,
        tagType: '',
        taggableType: '',
      },
      newDeniedTaggingRuleForm: {
        tagId: id,
        tagType: '',
        taggableType: '',
      },
      deleted: false,
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function updateTheUpdateTagForm(value) {
    dispatch((state) => ({
      ...state,
      updateTagForm: {
        ...state.updateTagForm,
        value,
      },
    }));
  }

  function updateSelectedTagTypeOnNewAllowedTaggingRule(selectedTagType) {
    dispatch((state) => ({
      ...state,
      newAllowedTaggingRuleForm: {
        ...state.newAllowedTaggingRuleForm,
        tagType: selectedTagType,
      },
    }));
  }

  function updateSelectedTaggableTypeOnNewAllowedTaggingRule(selectedTaggableType) {
    dispatch((state) => ({
      ...state,
      newAllowedTaggingRuleForm: {
        ...state.newAllowedTaggingRuleForm,
        taggableType: selectedTaggableType,
      },
    }));
  }

  function updateSelectedTagTypeOnNewDeniedTaggingRule(selectedTagType) {
    dispatch((state) => ({
      ...state,
      newDeniedTaggingRuleForm: {
        ...state.newDeniedTaggingRuleForm,
        tagType: selectedTagType,
      },
    }));
  }

  function updateSelectedTaggableTypeOnNewDeniedTaggingRule(selectedTaggableType) {
    dispatch((state) => ({
      ...state,
      newDeniedTaggingRuleForm: {
        ...state.newDeniedTaggingRuleForm,
        taggableType: selectedTaggableType,
      },
    }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    updateTheUpdateTagForm,
    updateSelectedTagTypeOnNewAllowedTaggingRule,
    updateSelectedTaggableTypeOnNewAllowedTaggingRule,
    updateSelectedTagTypeOnNewDeniedTaggingRule,
    updateSelectedTaggableTypeOnNewDeniedTaggingRule,
    clearFeedback,
  };
}
